import axios from "./axiosConfig";

const isUnauthorizedError = (error) => error?.response?.status === 401;

const buildHeaders = (token) => {
  if (!token) {
    return {};
  }

  return {
    Authorization: `Bearer ${token}`,
  };
};

class BaseService {
  static async get(endpoint, token, params = {}, config = {}) {
    try {
      const response = await axios.get(endpoint, {
        headers: buildHeaders(token),
        params: params,
        ...config
      });
      return response;
    } catch (error) {
      if (!isUnauthorizedError(error)) {
        console.error("Ocorreu um erro ao obter os dados!", error);
      }
      throw error;
    }
  }

  static async post(endpoint, data, token, params = {}) {
    try {
      const response = await axios.post(endpoint, data, { 
        headers: buildHeaders(token),
        params: params
      });
      return response;
    } catch (error) {
      if (!isUnauthorizedError(error)) {
        console.error("Ocorreu um erro ao postar os dados!", error);
      }
      throw error;
    }
  }

  static async put(endpoint, id, data, token = null, params = {}) {
    try {
      const response = await axios.put(`${endpoint}/${id}`, data, { 
        headers: buildHeaders(token),
        params: params
      });
      return response;
    } catch (error) {
      if (!isUnauthorizedError(error)) {
        console.error("Ocorreu um erro ao editar os dados!", error);
      }
      throw error;
    }
  }

  static async delete(endpoint, id, token, params = {}) {
    try {
      const response = await axios.delete(`${endpoint}/${id}`, { 
        headers: buildHeaders(token),
        params: params
      });
      return response;
    } catch (error) {
      if (!isUnauthorizedError(error)) {
        console.error("Ocorreu um erro ao excluir os dados!", error);
      }
      throw error;
    }
  }
}

export default BaseService;